import PropTypes from "prop-types";
import {useCallback, useContext, useEffect, useState} from "react";
import {AppDataContext} from "../../../App";
import UseApiManager from "../../../core/manager/api";
import MaplibreManager, {OverwriteMode} from "../../../core/manager/maplibre";


const SourceName = {
    Point: "survey-point-point",
    Line: "survey-point-line",
}

export const LayerName = {
    Line: {id: "survey-point-line-layer", at: 0},
    Symbol: {id: "survey-point-symbol-layer", at: 1},
}

const MapSurveyPointLayer = ({map, style, visible, onInit}) => {

    const { state } = useContext(AppDataContext)
    const [lineUrl, setLineUrl] = useState()
    const [pointUrl, setPointUrl] = useState()
    const { QueryVectorTileUrl } = UseApiManager()
    const { removes, addLayer, addVectorSource, setVisible, zoomInterpolate } = MaplibreManager()

    useEffect(() => {
        QueryVectorTileUrl(`
        SELECT the_geom_webmercator, kflg as start0_end1_kflg FROM ${state.env.CLIENT_ROUTE_START_END_TABLE}
        WHERE kflg = 0 OR kflg = 1
        `).then(setPointUrl)

        QueryVectorTileUrl(`
        SELECT the_geom_webmercator FROM ${state.env.CLIENT_ROUTE_LINE_TABLE}
        `).then(setLineUrl)

    }, [state])

    useEffect(() => {
        if (!map || !pointUrl || !lineUrl) { return }

        setTimeout(initLayer, 500)

        return () => {
            removes(map, {sources: SourceName, layers: LayerName})
        }

    }, [map, style, pointUrl, lineUrl])

    useEffect(() => {
        setVisible(map, LayerName, visible)
    }, [map, style, visible])

    const initLayer = useCallback(() => {
        if (!map || !pointUrl || !lineUrl) { return }

        addVectorSource(map, SourceName.Point, pointUrl, OverwriteMode.Rewrite)
        addVectorSource(map, SourceName.Line, lineUrl, OverwriteMode.Rewrite)

        addLayer(map, {
            id: LayerName.Line.id,
            type: "line",
            source: SourceName.Line,
            sourceLayer: "layer0",
            layout: {
                lineJoin: "round",
                lineCap: "round",
                visibility: visible ? "visible" : "none",
            },
            paint: {
                lineColor: "#50F345A0",
                lineWidth: zoomInterpolate({8:0.1, 10:0.5, 14:1, 18:5}),
                lineOpacity: 0.8,
            }
        })

        addLayer(map, {
            id: LayerName.Symbol.id,
            type: "symbol",
            source: SourceName.Point,
            sourceLayer: "layer0",
            layout: {
                iconImage: [
                    "case",
                    ["==", ["get", "start0_end1_kflg"], 1], "triangle-icon",
                    "circle-icon",
                ],
                iconSize: zoomInterpolate({8:0, 10:0.01, 12:0.1, 16:0.2}),
                iconIgnorePlacement: true,
                iconAllowOverlap: true,
                visibility: visible ? "visible" : "none",
            }
        }, OverwriteMode.Rewrite)

        setVisible(map, LayerName, visible)
        onInit && onInit()
    }, [map, pointUrl, lineUrl, visible])

    return null
}

MapSurveyPointLayer.propTYpes = {
    map: PropTypes.any,
    style: PropTypes.string,
    visible: PropTypes.bool,
    onInit: PropTypes.func,
}

export default MapSurveyPointLayer
